/* ==========================================================================
   MERVISO — Scripts base (vanilla, sin librerías externas)
   ========================================================================== */

function mvInitAll() {
  initReveal();
  initCountUp();
  initMarquee();
  initBeforeAfter();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mvInitAll);
} else {
  mvInitAll();
}

/* --------------------------------------------------------------------------
   1) Reveal al hacer scroll — añade .mv-visible cuando el elemento entra
   -------------------------------------------------------------------------- */
function initReveal() {
  var targets = document.querySelectorAll('.mv-reveal, .mv-reveal-stagger');
  if (!targets.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    targets.forEach(function (el) { el.classList.add('mv-visible'); });
    return;
  }

  // Seguro: si por lo que sea el observador no dispara (p. ej. dentro del
  // editor de Shopify al añadir una sección nueva), esto fuerza que el
  // contenido se vea igualmente a los 2 segundos.
  setTimeout(function () {
    targets.forEach(function (el) { el.classList.add('mv-visible'); });
  }, 2000);

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

  targets.forEach(function (el) { observer.observe(el); });
}

/* --------------------------------------------------------------------------
   2) Cifras animadas — <span class="mv-countup" data-target="500">
   -------------------------------------------------------------------------- */
function initCountUp() {
  var counters = document.querySelectorAll('.mv-countup');
  if (!counters.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      observer.unobserve(el);

      if (prefersReduced) {
        el.textContent = target + suffix;
        return;
      }

      var duration = 1400;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.floor(eased * target);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target + suffix;
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });

  counters.forEach(function (el) { observer.observe(el); });
}

/* --------------------------------------------------------------------------
   3) Marquesina infinita — duplica el contenido de .mv-marquee-track
   -------------------------------------------------------------------------- */
function initMarquee() {
  var tracks = document.querySelectorAll('.mv-marquee-track');
  tracks.forEach(function (track) {
    if (track.dataset.mvCloned) return;
    var clone = track.innerHTML;
    track.innerHTML = track.innerHTML + clone;
    track.dataset.mvCloned = 'true';
  });
}

/* --------------------------------------------------------------------------
   4) Comparador antes/después con deslizador
   -------------------------------------------------------------------------- */
function initBeforeAfter() {
  var wraps = document.querySelectorAll('.mv-ba');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.mv-ba-handle');
    var after = wrap.querySelector('.mv-ba-after');
    if (!handle || !after) return;

    var dragging = false;

    function setPosition(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      handle.style.left = pos + '%';
    }

    handle.addEventListener('pointerdown', function () { dragging = true; });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPosition(e.clientX);
    });
    wrap.addEventListener('click', function (e) {
      setPosition(e.clientX);
    });
  });
}
